/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMiscUserM = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 128 128"
  >
    <path fill="#F6F6F6" d="M0 0h128v128H0z" />
    <path
      fill="#B4B4B4"
      d="M89.1 49.8c-.9 4.5-2.2 8.9-3.5 11.9-3.3-1.5-.2-13.4-2.3-16.6-8.3-9-5.6-21.1-5.6-21.1s-1.4 5.5-7.4 5.5c-12.6 0-17.6-.1-22.9 6.1-4 4.7-4.2 15.4-4.2 21.2 0 5.4-2 5-2 5s-1.2-3.9-3.1-12.1H38c-1.8.3-2.6 4.8-1.7 9.9.9 5.2 3.1 9.1 4.9 8.8.4-.1.6 0 .9-.4.3 1.7.5 3.9 1.6 6.7 1 2.7 2.2 4.9 4.1 7.5v13.9c0 2.2 3.4 4 7.2 6.3 8.6 5.1 8.6 12.5 8.6 13.4 0-.8 0-8.3 8.5-13.3 5.5-3.3 7-5 7.2-6.1V82.3c2-2.7 3.3-5 4.3-8C84.4 72 85 68 85 68c.2.2.4.4.7.5 1.8.3 4-3.6 4.9-8.8.9-5 .2-9.3-1.5-9.9zm.8-15.8c.3 1.2.4 2.4.5 3.5 0-1.1-.1-2.3-.5-3.5z"
    />
    <path
      fill="#9F9F9F"
      d="M47.7 36.8c5.2-6.2 10.2-6 22.6-6 6 0 7.3-5.5 7.3-5.5S75 37.4 83.2 46.4c2.1 3.2-1 15.1 2.2 16.6 2.6-6 5.2-17.7 4.8-24.2-.4-6.5-3.1-14.1-11.3-17-2.4-7.6-9.6-9.8-15-10.9-.7 2.1-3.6 4.9-7 5.8-.1-.9.1-2 1.7-4C49.5 16.2 47.1 19 46 23c0 0-12.6 5.4-8.1 25.7 2.1 9.6 3.6 14.2 3.6 14.2s1.9.4 1.9-5c.1-5.7.3-16.3 4.3-21.1"
    />
    <path
      fill="#DCDCDC"
      d="M124.3 116.7c-2.8-9.6-23.9-16.3-31.4-18.4-1-.3-2-.6-3.2-.9-4.5-6-7.4-8.3-11-10.7v9.1c-.3 1.1-1.7 2.8-7.1 6-8.4 4.9-8.4 12.3-8.4 13.1 0-.9 0-8.1-8.5-13.2-3.7-2.2-7.1-4.1-7.1-6.2v-8.9c-2.9 1.8-6.3 4.6-10.9 10.6h-.1s-1.2.3-3.1.8c-8.6 2.2-28.4 9.1-30.2 18.2-1 5.9.3 11.8.3 11.8h121s1.1-6.3-.3-11.3"
    />
    <path
      fill="#C7C7C7"
      d="M63.6 89.2c-7 0-12.1-3.6-15.5-8.2 1.2 4 12.1 18.8 31 13.9v-14c-3.8 4.8-9.2 8.3-15.5 8.3"
    />
  </svg>
);

IconMiscUserM.displayName = 'IconMiscUserM';

IconMiscUserM.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMiscUserM);
IconMiscUserM.displayName = 'IconMiscUserM';
